import React, { FC, useRef, useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import { cn } from 'shared/utils'

import 'react-quill/dist/quill.snow.css'

import { FeedEditorProps } from './FeedEditor.props'

import { toolbarModules } from 'shared/quill/editorOptions'

import { isNestedObjEqual } from 'shared/utils'

import './FeedEditor.scss'

const FeedEditor: FC<FeedEditorProps> = ({
  value,
  setValue,
  isDisabled,
  setValueChanged,
  dataTest,
  placeholder = 'Insert text here ...'
}) => {
  const editorRef = useRef<any>()
  const [initialContent, setInitialContent] = useState()

  useEffect(() => {
    if (editorRef && editorRef.current) {
      setInitialContent(editorRef.current.unprivilegedEditor.getContents())
    }
  }, [])

  useEffect(() => {
    if (editorRef && editorRef.current && initialContent) {
      setValueChanged(!isNestedObjEqual(initialContent, editorRef.current.unprivilegedEditor.getContents()))
    }
  }, [editorRef, initialContent, value, setValueChanged])

  return (
    <div
      data-test={dataTest}
      className={cn('feed-editor', {
        'feed-editor--disabled': isDisabled
      })}
    >
      <ReactQuill
        preserveWhitespace
        theme="snow"
        modules={toolbarModules.extended}
        value={value}
        onChange={setValue}
        placeholder={placeholder}
        readOnly={isDisabled}
        ref={editorRef}
      />
    </div>
  )
}

export default FeedEditor
